export type DisputeTextTag = 'b' | 'hl';

export interface TaggedTextSpan {
  text: string;
  tag?: DisputeTextTag;
}

const OPEN_TAG = /^<(b|hl)>/;
const CLOSE_TAG = /^<\/(b|hl)>/;
const UNKNOWN_TAG = /^<[^>]*>/;

const stripTags = (value: string): string => value.replace(/<[^>]*>/g, '');

const pushSpan = (spans: TaggedTextSpan[], text: string, tag?: DisputeTextTag) => {
  if (!text) return;
  spans.push(tag ? { text, tag } : { text });
};

export const parseTaggedText = (input?: string | null): TaggedTextSpan[] => {
  if (!input) return [];

  const spans: TaggedTextSpan[] = [];
  let plain = '';
  let index = 0;

  const flushPlain = () => {
    pushSpan(spans, plain);
    plain = '';
  };

  while (index < input.length) {
    if (input[index] !== '<') {
      plain += input[index];
      index += 1;
      continue;
    }

    const rest = input.slice(index);
    const openTag = rest.match(OPEN_TAG);
    if (openTag) {
      const tag = openTag[1] as DisputeTextTag;
      const closeToken = `</${tag}>`;
      const contentStart = index + openTag[0].length;
      const closeAt = input.indexOf(closeToken, contentStart);
      if (closeAt === -1) {
        index = contentStart;
        continue;
      }
      flushPlain();
      pushSpan(spans, stripTags(input.slice(contentStart, closeAt)), tag);
      index = closeAt + closeToken.length;
      continue;
    }

    const closeTag = rest.match(CLOSE_TAG);
    if (closeTag) {
      index += closeTag[0].length;
      continue;
    }

    const unknownTag = rest.match(UNKNOWN_TAG);
    if (unknownTag) {
      index += unknownTag[0].length;
      continue;
    }

    plain += input[index];
    index += 1;
  }

  flushPlain();
  return spans;
};
